import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function LegalPage({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <article className="mx-auto max-w-4xl pb-10">
      <Link to="/" className="text-[14px] font-semibold text-accent">
        ← На главную
      </Link>
      <div className="mt-5">
        <p className="text-[12px] font-semibold uppercase tracking-[0.12em] text-muted">Документ</p>
        <h1 className="mt-2 text-[36px] font-semibold leading-[1.08] tracking-[-0.02em] text-ink md:text-[54px]">
          {title}
        </h1>
        <p className="mt-3 max-w-2xl text-[15.5px] leading-6 text-muted md:text-[17px]">
          {subtitle ?? 'Документ действует для всех пользователей lex.ai.'}
        </p>
      </div>
      <div className="mt-7 space-y-4 rounded-3xl border border-line bg-white/90 p-6 text-[15px] leading-[1.7] text-muted md:p-8">
        {children}
      </div>
      <p className="mt-4 text-[12.5px] text-muted">
        Вопросы по документу: <a href="mailto:help@lex.ai" className="font-semibold text-accent">help@lex.ai</a>
      </p>
    </article>
  );
}
